import { styled } from '@mui/material/styles';
import MuiTableRow from '@mui/material/TableRow';

const StyledTableDataRow = styled(MuiTableRow, {
    shouldForwardProp: prop => ![
        'rowHeight',
        'rowWidth',
        'isOver',
        'canDrop',
        'isClicked',
        'hidden',
        'isDragged',
        'isDragging',
        'rtl',
        'skeleton',
        'forceHover',
    ].includes(prop),
}) `
  ${({ theme, hidden, rowHeight, rowWidth, isOver, canDrop, isClicked, isDragged, isDragging, rtl, skeleton, forceHover, }) => `
      display: flex;
      position: relative;
      border-radius: 4px;
      user-select: none; 
      direction: ${rtl ? 'rtl' : 'ltr'};
      margin: ${theme.spacing(2, 0)};
      min-height: ${rowHeight - 4}px;
      max-height: ${rowHeight - 4}px;
      height: ${rowHeight - 4}px !important;
      width: ${rowWidth ? `${rowWidth}px !important` : `${skeleton ? '100%' : 'auto'} !important`};
      border: solid 1px ${(isOver && canDrop) || isClicked ? theme.palette.primary.main : 'transparent'};
      background-color: ${isClicked && !isDragged ? theme.palette.N70.main : theme.palette.N80.main};
      opacity: ${isDragged ? '0.1' : hidden ? '0.5' : '1'};
      right: ${rtl ? '0' : 'auto'} !important;
      left: ${rtl ? 'auto' : '0'} !important;

      .highlighted-text {
        background: ${theme.palette.primary.light} !important;
        color: ${theme.palette.N95.main};
      }
      
      ${!!isClicked &&
    `
          p {
              color: ${theme.palette.N05.main};
          }
          div:nth-of-type(2) {
            p {
              color: ${theme.palette.N10.main};
            }
          }
        `}
      
      .ops-row-selection-icon {
        opacity: 1;
      }
      .ops-row-selection-checkbox {
        opacity: 0;  
      }
      .ops-row-selection-drag {
        opacity: 1;  
      }
      
      ${forceHover
    ? `
            background-color: ${theme.palette.N70.main};
          `
    : ``} 
      
      &.Mui-selected {
        border-radius: 4px;
        background-color: ${!isDragged ? theme.palette.N60.main : theme.palette.N80.main};
        opacity: ${isDragged ? '0.1' : hidden ? '0.5' : '1'};
        
        p {
          color: ${theme.palette.N05.main};
        }
        &:hover {
          background-color: ${theme.palette.N50.main};
        }
        &:hover .op-row-menu-column {
          background-color: ${theme.palette.N50.main};
        }
        .ops-row-selection-icon {
          opacity: 0;
        }
        .ops-row-selection-checkbox {
          opacity: 1;  
        }
        .ops-row-selection-drag {
          opacity: 1;  
        }
      }
     
      
      ${!isDragging &&
    !skeleton &&
    `
          &:not(:hover) {
            .ops-row-selection-drag {
              visibility: hidden;
            }
          }
          &:hover {
            opacity: 1;
            
            .ops-row-selection-icon {
                visibility: hidden;
            }
            
            .ops-row-selection-checkbox {
              opacity: 1;
            }
            .ops-row-selection-drag {
              visibility: visible;
            }

          }

          &:hover:active {
             opacity: 1;

            .ops-row-selection-icon {
                visibility: hidden;
               }
            
            .ops-row-selection-checkbox {
              opacity: 1;
              transition: opacity 1s ease-in;
              
            }
          }

        `}
      
       ${!isDragging &&
    !skeleton &&
    `
        &:hover {
          background-color: ${isDragged ? 'transparent' : theme.palette.N70.main};
          p {
              color: ${theme.palette.N05.main};
          }
          .op-row-menu-column {
            background-color: ${isDragged ? 'transparent' : theme.palette.N70.main};
          }
          
          .ops-row-action-menu {
            opacity: 1;
          }
          
          .ops-cell-action-items {
            position: initial;
            left: 0;
            opacity: 1;
          }
        }
        `}    
    `}
`;

export { StyledTableDataRow as default };
//# sourceMappingURL=StyledTableDataRow.js.map
